export const CLPatientInfoTabs = ['칼로리 기록', '메시지 전달'];

export const CLPatientInfoChartFilterList = ['지난 7일간', '지난 14일간', '지난 21일간', '지난 1개월간', '지난 3개월간'];

export const CLMessageBedge = [
    {
        label: '진료 안내',
        value: 'MEDICAL_GUIDE',
    },
    {
        label: '칼로리 관리',
        value: 'CALORIE_MANAGEMENT',
    },
    {
        label: '기타',
        value: 'ETC',
    },
];

export const CLManagingPatientSearchFilterList = ['전체', '이름', '연락처'];

export const CLUserLookupSearchFilterList = ['전체', '이름', '연락처', '이메일'];

export const adminAssessmentPaymentSearchFilterList = ['전체', '병원', '이름'];
